import {makeSystemModePath} from './shared/serverFunctions';

/**
 * Discounts
 *      All, Filters
 *      by: Location, Loyalty, DBA, District, State
 *      by: State & City, State & DBA
 */
export const RESOURCES = {
    "DiscountsCountByDateRange": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsCount/" + startEndOffset
            }
        }
    },
    "DiscountsSalesAll": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales (All)",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsByDateRange/" + startEndOffset
            }
        }
    },
    "DiscountsSalesCountByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sale/" + systemMode + "/" + params.location_id + "/discountsCountByLocation/"+ startEndOffset
            }
        }
    },
    "DiscountsSalesByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales by Location",
                "uri": localStorage.getItem('server') + "/api/v5/report/sale/" + systemMode + "/" + params.location_id + "/discountsByLocationDateRange/" + startEndOffset
            }
        }
    },
    "DiscountsSalesCountByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsCountByDBA/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales by DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsByDBADateRange/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesCountByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsCountByDistrict/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales by District",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsByDistrictDateRange/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesCountByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsCountByState/" + params.state + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales by State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsByStateDateRange/" + params.state + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesCountByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsCountByCityState/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales by City and State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsByCityStateDateRange/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesCountByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsCountByDBAState/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales by City and DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsByDBAStateDateRange/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesCountByLoyaltyAccount": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales Count by Loyalty Account",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsCountByLoyalty/" + params.loyalty_id + "/" + startEndOffset
            }
        }
    },
    "DiscountsSalesByLoyaltyAccount": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts Sales by Loyalty Account",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsByLoyaltyDateRange/" + params.loyalty_id + "/" + startEndOffset
            }
        }
    },
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "ItemSalesByState"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseDiscountsReportsResourceMap.js